import { GenIcon } from '../helpers/IconBase.es.js';

const PencilOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 16 16", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M15.2353 0.742842C14.7821 0.290306 14.1678 0.0361328 13.5273 0.0361328C12.8869 0.0361328 12.2726 0.290306 11.8193 0.742842L0.976677 11.5855C0.666178 11.8943 0.419985 12.2615 0.252342 12.666C0.0846994 13.0706 -0.00106532 13.5043 9.98748e-06 13.9422V15.3108C9.98748e-06 15.4877 0.0702479 15.6572 0.195272 15.7822C0.320296 15.9073 0.489866 15.9775 0.666677 15.9775H2.03534C2.47319 15.9787 2.90692 15.8931 3.31145 15.7256C3.71597 15.5581 4.08325 15.3119 4.39201 15.0015L15.2353 4.15817C15.6877 3.70497 15.9417 3.09082 15.9417 2.45051C15.9417 1.8102 15.6877 1.19604 15.2353 0.742842ZM3.44934 14.0588C3.07335 14.4323 2.56532 14.6426 2.03534 14.6442H1.33334V13.9422C1.33267 13.6794 1.38411 13.4192 1.4847 13.1765C1.58529 12.9338 1.73302 12.7134 1.91934 12.5282L10.148 4.29951L11.6813 5.83284L3.44934 14.0588ZM14.292 3.21551L12.6213 4.88684L11.088 3.35684L12.7593 1.68551C12.86 1.58505 12.9795 1.5054 13.111 1.45111C13.2424 1.39683 13.3833 1.36897 13.5255 1.36912C13.6678 1.36928 13.8086 1.39744 13.9399 1.45202C14.0712 1.50659 14.1905 1.58649 14.291 1.68717C14.3915 1.78785 14.4711 1.90734 14.5254 2.0388C14.5797 2.17026 14.6076 2.31112 14.6074 2.45335C14.6072 2.59558 14.5791 2.73639 14.5245 2.86773C14.4699 2.99907 14.39 3.11838 14.2893 3.21884L14.292 3.21551Z",
          fill: "#0200BC"
        }
      }
    ]
  })(props);
};

export { PencilOutlined };
